import React, { useCallback } from 'react'
import { FiXCircle } from 'react-icons/fi'
import { useSelector } from 'react-redux'
import { Spinner } from 'reactstrap'

import PropTypes from 'prop-types'

import { Button } from '~/components/Buttons'
import Loading from '~/components/Loading'
import useConfirmationModal from '~/hooks/useConfirmationModal'

import usePromotion from '../../hooks/usePromotion'

const CancelButton = ({ promotion, keepsMenuOpen, menuItem = false }) => {
  const [ConfirmationhModal, showConfirmationModal, toggleConfirmationModal] =
    useConfirmationModal()

  const { handleCancelPromotion } = usePromotion()

  const { loadingSaving: loading } = useSelector(state => state.promotional)

  const handleToogle = useCallback(() => {
    keepsMenuOpen && keepsMenuOpen(oldState => !oldState)

    toggleConfirmationModal()
  }, [keepsMenuOpen, toggleConfirmationModal])

  const handleSubmit = useCallback(() => {
    const data = {
      promotion,
      onSuccess: handleToogle
    }

    handleCancelPromotion(data)
  }, [handleCancelPromotion, promotion, handleToogle])

  return (
    <>
      {menuItem ? (
        <button type="button" onClick={handleToogle} className="danger">
          {loading ? <Spinner /> : <FiXCircle />} <span>Cancelar</span>
        </button>
      ) : (
        <Button
          text="Cancelar"
          type="button"
          template="transparentCritical"
          size="small"
          iconLeft={loading ? <Spinner /> : <FiXCircle />}
          customWidth="auto"
          onClick={handleToogle}
        />
      )}

      {/* Modal Cancelar */}
      <ConfirmationhModal
        title="Deseja cancelar a promoção?"
        isOpen={showConfirmationModal}
        onClose={handleToogle}
        onSubmit={handleSubmit}
        confirmationButton="Entendo e desejo cancelar esta promoção"
      >
        <p>
          Esta ação não poderá ser desfeita. A promoção permanecerá na listagem
          e poderá ser duplicada no futuro.
        </p>
        {loading && <Loading status={loading}>Cancelando promoção...</Loading>}
      </ConfirmationhModal>
    </>
  )
}

export default CancelButton

CancelButton.propTypes = {
  promotion: PropTypes.shape({}).isRequired,
  keepsMenuOpen: PropTypes.func,
  menuItem: PropTypes.bool
}

CancelButton.defaultProps = {
  menuItem: false,
  keepsMenuOpen: null
}
